import React from "react";
import "./../../UaeAttestation/UaeAbout/UaeAbout.css";
import qatarAbout from "./../../../../vid_img/qatarAbout.jpg";

const QatarAboutMain = () => {
  return (
    <div className="uaeAboutUsMainContainer">
      <div className="uaeAboutUsMainContent">
        <ul>
          <li>
            Qatar is one of the most advanced-economy countries in the Arab
            region and has the highest per capita income. Qatar wields
            considerable influence on the world state despite its small size.
          </li>
          <li>
            Make your Qatar travel formalities easier with elaborate document
            attestation. You may travel to Qatar for tour, business,
            immigration, job and many other reasons. Meet up with the friendly
            and helpful professionals at Goodway Attestation and get their
            guidance and advice about attestation services for Qatar in
            Bengaluru.
          </li>
          <li>
            You need not go beyond Goodway Attestation for document attestation
            services for Qatar in Bengaluru.
          </li>
          <li>
            Ensure minimal hassle during either admission to a higher education
            institution or background verification at the time of newly joining
            a company in Qatar. Our professionals will be glad to help you with
            educational certificates attestation for Qatar. You can also get
            your work experience certificates attested for Qatar, at Goodway
            Attestation, Bengaluru.
          </li>
          <li>
            Certain rules and regulations require that your documents be
            attested by the Embassy of Qatar. Make your task easier by
            approaching our friendly and helpful professionals at Goodway
            Attestation to get all your documents and certificates attested by
            the Embassy of Qatar, in Bengaluru itself.
          </li>
          <li>
            If you need to get your certificates, documents, and others attested
            by different authorities of Qatar,, you need not go out of
            Bengaluru. You just need to get the job done by the professionals at
            Goodway Attestation, in Bengaluru.
          </li>
        </ul>
      </div>
      <div className="uaeAboutUsMainContentImg">
        <img src={qatarAbout} alt="qatarAbout" />
      </div>
    </div>
  );
};

export default QatarAboutMain;
